import dayjs from 'dayjs';
import type { MeasureMetadata } from '../../api/work-periods-client/work-periods-client.type';
import { DEPRECATED_MEASURES } from '../../containers/process-analysis/process-analysis.constants';
import { Tab } from '../../containers/process-analysis/process-analysis.type';
import type { ComparisonModeFilters } from './process-analysis-store.type';

/**
 * Gets the first and last day of the previous month in YYYY-MM-DD format.
 *
 * @return {{ firstDay: string, lastDay: string }} Object containing first and last day strings
 */
const getLastMonthDateRange = (): { firstDay: string; lastDay: string } => {
  const lastMonth = dayjs().subtract(1, 'month');
  const firstDay = lastMonth.startOf('month').format('YYYY-MM-DD');
  const lastDay = lastMonth.endOf('month').format('YYYY-MM-DD');

  return { firstDay, lastDay };
};

/**
 * Filters out deprecated measures from a list of measures
 *
 * @param {MeasureMetadata} measure - The measure metadata to check
 * @returns {boolean} True if the measure is not deprecated, false if it is deprecated
 */
const filterDeprecatedMeasures = (measure: MeasureMetadata): boolean => {
  return !DEPRECATED_MEASURES.includes(measure.measure_name);
};

/**
 * Filters out custom measures from a list of measures
 *
 * @param {MeasureMetadata} measure - The measure metadata to check
 * @returns {boolean} True if the measure is not custom, false if it is custom
 */
const filterCustomMeasures = (measure: MeasureMetadata): boolean => {
  return !measure.is_custom;
};

/**
 * Gets the default comparison mode filters structure for all tabs
 *
 * @returns {Record<Tab, ComparisonModeFilters>} Object containing default filters for each tab
 */
const getDefaultComparisonModeFilters = (): Record<Tab, ComparisonModeFilters> => {
  const defaultComparisonModeFilters: ComparisonModeFilters = {
    selectedMeasureOverTime: null,
    selectedMeasureOverTimeTrend: false,
    selectedMonthlyAveragesMeasures: [],
  };

  return {
    [Tab.Portfolios]: { ...defaultComparisonModeFilters },
    [Tab.Teams]: { ...defaultComparisonModeFilters },
    [Tab.Boards]: { ...defaultComparisonModeFilters },
    [Tab.Agents]: { ...defaultComparisonModeFilters },
  };
};

export { filterCustomMeasures, filterDeprecatedMeasures, getDefaultComparisonModeFilters, getLastMonthDateRange };
